<template>
  <div @click="expandCart(false)" class="cart-container" :class="[expanded == true ? 'expanded' : '', selectedAddonProducts.length > 0 ? 'hasProduct' : '',isSticking ? 'sticky' : '',step > 1 ? 'global' : '']">
      <div v-on:click.stop class="unexpanded-cart" :class="isSticking ? 'sticking' : ''" v-if="expanded == false">
        <div @click="expandCart(true)" class="expand-arrow">
            <span>Expand</span>
            &lt;
        </div>
        <div id="cart-header">
            <div class="price-container">
            <span class="title">Price per Box</span>
            <span class="price">{{ totalPrice | moneySaleFormat}}</span>
        </div>
        <p class="qty-box-title">Qty of Boxes:</p>
        <select v-model="selectedBoxQty" id="boxqtyselector" @change="changeBoxQty(null)">
            <option v-for="qty in boxMaxQty" :key="qty" :value="qty">{{qty}}</option>
        </select>
        <p class="products-container-title">Your Gift:</p>
        </div>
        <ul id="products-scroll-container" class="products-container no-scrollbar scrollList" @scroll="handleScroll">
            <li v-for="(addonProduct, index) in selectedAddonProducts" :key="addonProduct.variants[0].id" :id="`product-${index}`" :class="isOverflow(addonProduct) ? 'overflow-product' : ''">
                <div class="alert-overlay" v-if="!extendedAlert && isExtendedBoxes && extendedProducts.includes(addonProduct.title) && step == 2 && !isOverflow(addonProduct)">
                    <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/i_icon_554a1a74-64ad-404e-9f6e-47fe1431b3ea.svg?v=1753797241"  @click="() => {extendedAlert = true}" class="alert-icon"/>
                </div>
                <div v-if="extendedAlert && isExtendedBoxes && extendedProducts.includes(addonProduct.title) && step == 2 && !isOverflow(addonProduct)" class="extended-block">
                    <p @click="() => {extendedAlert = false}" class="close">X</p>
                    <p><strong>Swap this gift for a smaller one to view cheaper box options</strong></p>
                    <div class="arrow-t">
                        <div class="inner"></div>
                    </div>
                </div>
                <div v-if="isOverflow(addonProduct) && overflowAlert && step == 2" 
                     class="overflow-alert" 
                     :style="getOverflowAlertStyle(index)"
                     :class="{ 'hidden': !isProductVisible(index) }">
                    <p @click="() => {overflowAlert = false}" class="close cursor-pointer">X</p>
                    <p>Due to this particular product's size, <br/> the <strong>{{addonProduct.title}}</strong> may be packed <br/> outside the Happy Box, in an outer box.</p>
                    <div class="arrow-t">
                        <div class="inner"></div>
                    </div>
                </div>
                <div class="addon-container">
                    <img class="main-image" loading="lazy" :src="getProductImage(addonProduct)" >
                    <select  v-model="addonProduct.quantity" @change="changeOnDemand(addonProduct)">
                        <option v-for="qty in addonMaxQty(addonProduct)" :key="qty" :value="qty">{{qty}}</option>
                    </select>
                    <img @click="removeProduct(addonProduct)" class="delete-button" src="https://cdn.shopify.com/s/files/1/1363/8433/files/trash_05a3e1b5-b394-4f91-aaf3-599964c057cb.svg?v=1659632833">
                </div>
            </li>
            <li v-if="selectedBoxProduct">
                <div class="addon-container">
                    <img class="main-image" loading="lazy" :src="selectedBoxProduct | getProductImage" >
                    <div class="edit-container" @click="goStep(2)">
                        <p>Edit Box</p>
                        <img class="switch-button" src="https://cdn.shopify.com/s/files/1/1363/8433/files/edit_icon_f176cdac-9643-4c58-a500-4a8c1cb57c27.svg?v=1725042634">
                    </div>
                </div>
            </li>
            <li v-if="selectedCardProduct">
                <div class="addon-container">
                    <img class="main-image" :src="selectedCardProduct | getProductImage" >
                    <div class="edit-container" @click="goStep(3)">
                        <p>Edit Card</p>
                        <img class="switch-button" src="https://cdn.shopify.com/s/files/1/1363/8433/files/edit_icon_f176cdac-9643-4c58-a500-4a8c1cb57c27.svg?v=1725042634">
                    </div>
                </div>
            </li>
        </ul>
        <button @click="changePage(true)" class="happybox-button green border">Next Step ></button>
      </div>
      <div v-on:click.stop class="expanded-cart" v-else>
            <div @click="expandCart(false)" class="expand-arrow">
                <span>Collapse</span>
                >
            </div>
            <div class="product-summary-container no-scrollbar">
                <div class="box-name-container">
                    <img width="20px" height="20px" class="h-auto m-r-05rem" src="https://cdn.shopify.com/s/files/1/1363/8433/files/gift_blue.svg?v=1749489581"/>
                    <!-- <p v-tooltip="{content: boxAlert, show: showBoxAlert, trigger: ['manual']}" class="box-name" v-if="isEditingName == false">{{boxName}}</p> -->
                    <input placeholder="Give Your Box a Name" v-on:keyup.enter="editName(false)" @blur="checkName()" class="body-base placeholder-italic" type="text" maxlength="34" v-model="boxName">
                    <!-- <button class="box-name-legend" @click="editName(true)" v-if="isEditingName == false"> <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/icon.png?v=1658429893"/>Give your box a name to keep your cart organized</button> -->
                </div>
                <div class="product-summary">
                    <p class="summary-title">Box Contents</p>
                    <p class="summary-subtitle" v-if="productQtyCopy">{{ productQtyCopy }}</p>
                    <ul class="products-container">
                        <li v-for="addonProduct in selectedAddonProducts" :key="addonProduct.variants[0].id">
                            <div class="addon-container">
                                <div class="image-container">
                                    <img @click="openModalProduct(addonProduct)" class="main-image lazyload" width="100" height="100" loading="lazy" :src="getProductImage(addonProduct)" >
                                </div>
                                <div class="product-information">
                                    <div>
                                        <p @click="openModalProduct(addonProduct)" class="title">{{addonProduct.title}}</p>
                                        <p class="price">${{addonProduct.variants[0].price}}</p>
                                    </div>
                                    <div class="product-qty-container">
                                        <select v-model="addonProduct.quantity" @change="changeOnDemand(addonProduct)">
                                            <option v-for="qty in addonMaxQty(addonProduct)" :key="qty" :value="qty">{{qty}}</option>
                                        </select>
                                        <img @click="removeProduct(addonProduct)" class="delete-button" src="https://cdn.shopify.com/s/files/1/1363/8433/files/trash_05a3e1b5-b394-4f91-aaf3-599964c057cb.svg?v=1659632833">
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li v-if="selectedBoxProduct">
                            <div class="addon-container">
                                <div class="image-container">
                                    <img class="main-image lazyload" width="100" height="100" :src="selectedBoxProduct | getProductImage" >
                                </div>
                                <div class="product-information">
                                    <div>
                                        <p class="title">{{selectedBoxProduct.title}}</p>
                                        <p class="price">${{selectedBoxProduct.variants[0].price}}</p>
                                    </div>
                                    <div class="product-qty-container">
                                        <img @click="goStep(2)" class="switch-button" src="https://cdn.shopify.com/s/files/1/1363/8433/files/edit_icon_f176cdac-9643-4c58-a500-4a8c1cb57c27.svg?v=1725042634">
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li v-if="selectedCardProduct">
                            <div class="addon-container">
                                <div class="image-container">
                                    <img class="main-image lazyload" width="100" height="100" :src="selectedCardProduct | getProductImage" >
                                </div>
                                <div class="product-information">
                                    <div>
                                        <p class="title">{{selectedCardProduct.title}}</p>
                                        <p class="price">${{selectedCardProduct.variants[0].price}}</p>
                                    </div>
                                    <div class="product-qty-container">
                                        <img @click="goStep(3)" class="switch-button" src="https://cdn.shopify.com/s/files/1/1363/8433/files/edit_icon_f176cdac-9643-4c58-a500-4a8c1cb57c27.svg?v=1725042634">
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <button @click="goStep(1)" class="remove-all color-link underline  flex flex-align-center flex-justify-between gap-05vw">
                        <img width="15px" height="10px" class="h-auto" src="https://cdn.shopify.com/s/files/1/1363/8433/files/edit.svg?v=1749479131"/>
                        Edit gifts
                    </button>
                </div>
                <div class="box-container">
                    <div class="box-qty-container">
                        <p>Box Quantity</p>
                        <div class="box-qty-input-container">
                            <button @click="incrementBoxQty(false)">-</button> 
                            <input @blur="changeBoxQty(null)" v-model="selectedBoxQty" type="number" min="1"> 
                            <button @click="incrementBoxQty(true)">+</button> 
                        </div>
                    </div>
                    <p class="multiship-notice">Adjust the quantity if you'd like duplicates of this box, even if you're shipping to different addresses!</p>
                    <p class="custom-notice" v-if="customAlert && hasCustomProducts">{{customAlert}}</p>
                </div>
                <div v-if="recommendedAddons.length > 0" class="recommendation-container">
                    <p class="title">Perfect fit for your box</p>
                    <div class="recommended-addon-container">
                        <div class="recommended-addon" v-for="addon in recommendedAddons" :key="addon.id">
                            <img @click="openModalProduct(addon)" width="180" height="180" loading="lazy" :src="addon.image.src" class="main-image">
                            <button @click="updateReccomendedAddonProductQuantity(addon)" class="happybox-button white border">{{ addCopy }}</button>
                            <p @click="openModalProduct(addon)" class="addon-title">{{addon.title}}</p>
                            <p class="price">{{addon.variants[0].price | moneySaleFormat}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="price-summary-container no-scrollbar">
                <div class="x-container">
                    <img @click="expandCart(false)" class="x-button" src="https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652" alt="x"/>
                </div>
                <div class="notice-container">
                    <img class="main-image" src="https://cdn.shopify.com/s/files/1/1363/8433/files/boxwings.svg?v=1658459692"/>
                    <div>
                        <p class="title">Multiple addresses? No problem!</p>
                        <p class="subtitle">Ship to one or many locations all <br/> in one, easy checkout</p>
                        <a target="_blank" href="https://www.loom.com/share/d6c4740fe5534425a14581d913b91910?sid=672876ae-7e19-49bd-b06a-b75f17df94ac">Watch the Demo</a>
                    </div>
                </div>
                <div class="summary-container">
                    <div class="item-summary">
                        <p class="item-title">Box Summary</p>
                        <div class="box-total">
                            <div class="total-container">
                                <p v-if="boxQty > 1" class="title"><strong>({{boxQty}})</strong> {{boxName}}</p>
                                <p v-else class="title">{{boxName}}</p>
                                <p class="price">{{ gifsPrice * boxQty | moneySaleFormat}}</p>
                            </div>
                            <p class="individual-price">{{gifsPrice | moneySaleFormat}} per box</p>
                        </div>
                        <div class="box-total">
                            <div class="total-container">
                                <p class="title">Gift Box Design <span v-if="!selectedBoxProduct">(selected at next step)</span></p>
                                <p v-if="selectedBoxProduct" class="price">{{ boxPrice * boxQty | moneySaleFormat }}</p>
                                <p v-else class="price">$--</p>
                            </div>
                        </div>
                        <div class="box-total">
                            <div class="total-container">
                                <p class="title">Card <span v-if="!selectedCardProduct">(selected at future step)</span></p>
                                <p v-if="selectedCardProduct" class="price">{{ cardPrice * boxQty | moneySaleFormat }}</p>
                                <p v-else class="price">$--</p>
                            </div>
                        </div>
                        <div class="box-total">
                            <div class="total-container">
                                <p class="title">Handpacking Fee</p>
                                <p class="price">{{ feePrice * boxQty | moneySaleFormat }}</p>
                            </div>
                            <p class="purple-legend" v-if="hasOnDemandProducts"> Some items in your cart may  require 1-2 week lead time.  But trust us, they're worth the wait!</p>
                            <p v-else-if="hasCustomProducts" class="individual-price">Custom items require a lead time of at least 1-2 weeks. Our team will reach out via email to coordinate shipping details.</p>
                        </div>
                        <div class="item-total">
                            <p class="title">Item Total</p>
                            <p class="price">{{(totalPrice * boxQty) | moneySaleFormat}}</p>
                        </div>
                    </div>
                    <div class="taxes-container">
                        <p class="title">Taxes <strong>(calculated in checkout)</strong></p>
                        <p class="price">--</p>
                    </div>
                    <div class="separator"></div>
                    <div class="subtotal-container">
                        <p class="title">Estimated Subtotal</p>
                        <p class="price">{{(totalPrice * boxQty) | moneySaleFormat}}</p>
                    </div>
                </div>
                <div v-if="step != 3" class="complete-box">
                    <button @click="changePage(true)" class="hb-btn primary" :class="isloading ? 'isLoading' : ''">{{canCopy}}</button>
                </div>
                <div v-else class="complete-box">
                    <button @click="bundle(false)" class="hb-btn primary" :class="isloading ? 'isLoading' : ''">{{ bundleText }}</button>
                    <button @click="bundle(true)" class="color-link underline body-base">{{ bundleSecondaryText }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2/dist/sweetalert2.js'
import { mapGetters } from 'vuex';
export default {
    props: {
        isSticking: Boolean,
        step: Number,
        fromCard: Boolean
    },
    data() {
      return {
        expanded: false,
        isEditingName: false,
        selectedBoxQty: 1,
        isHovering: false,
        boxAlert: '',
        showBoxAlert: false,
        isloading: false,
        bulkOpen: true,
        extendedAlert: false,
        overflowAlert: true,
        visibleProducts: new Set(),
      }
    },
    watch: {
        boxQty: {
            handler(val){
                this.selectedBoxQty = val;
            },
            deep: true
        },
        cartLength:{
            handler(val,oldVal){
                if(val == 0 && this.step != 1){
                    this.goStep(1);
                }
                this.scrollBottom();
            }
        },
        selectedBoxProduct:{
            handler(){
                this.scrollBottom();
            }
        },
        selectedCardProduct:{
            handler(){
                this.scrollBottom();
            }
        },
        selectedAddonProducts: {
            handler() {
                this.$nextTick(() => {
                    this.updateVisibleProducts();
                });
            },
            deep: true
        }
    },
    computed:{
        ...mapGetters([
            'selectedAddonProducts',
            'maxCapacity',
            'currentCapacity',
            'productLimit',
            'addCopy',
            'defaulBoxName',
            'cartNames',
            'addonProducts',
            'boxQty',
            'selectedCardProduct',
            'selectedBoxProduct',
            'feeProduct',
            'selectedOccasion',
            'selectedCategories',
            'selectedFilters',
            'boxProducts',
            'cardHasMessage'
        ]),
        multishipCallout: {
            get(){ return this.$store.state.multishipCallout},
            set(value){this.$store.commit('setMultishipCallout', value )}
        },
        canCopy(){
            if (this.step == 2 && !this.selectedBoxProduct){
                return "Please select your box";
            }

            return "Next >"
        },
        cartLength(){
            return this.selectedAddonProducts.length;
        },
        currentMaxCapacity(){
            if(!this.selectedBoxProduct){
                return this.maxCapacity;
            }
            else{
                return parseInt(this.selectedBoxProduct.variants[0].option1)
            }
        },
        recommendedAddons(){
            if(this.addonProducts.length > 0){
                let filterAddons =  JSON.parse(JSON.stringify(this.addonProducts));
                //filter via occasion
                if(this.selectedOccasion.length > 0){
                    filterAddons = filterAddons.filter(x => x.tags.some(y => this.selectedOccasion.some(z => y.includes(z))));
                }

                //Filter categories
                if(!this.selectedCategories.includes("View All"))
                    filterAddons = filterAddons.filter(x => x.tags.some(y =>  this.selectedCategories.some(z => y.includes(z))));

                //Filter for each category
                for(let filter of this.selectedFilters){
                    filterAddons = filterAddons.filter(x => filter.filters.some(y => x.tags.includes(y)));
                }

                //Exclude products
                let excludeFilters = this.selectedAddonProducts.filter(x => x.tags.some(y => y.includes("Exclude_")));
                if(excludeFilters.length > 0){
                    let excludedTags = excludeFilters.flatMap(x => x.tags.filter(y => y.includes("Exclude_")));
                    excludedTags = excludedTags.map(x => parseInt(x.replaceAll("Exclude_","")));
                    filterAddons = filterAddons.filter(x => !excludedTags.includes(x.id));
                }
            
                var addonCartIds = this.selectedAddonProducts.map(x => x.id);
                if(filterAddons.length > 0){
                    let products = filterAddons.filter(x => !addonCartIds.includes(x.id) && x.tags.every(y => !y.includes("Brandable Swag") && !y.toLowerCase().includes("Pairs_exclude"))).slice(0,3);
                    if(products.length > 0)
                        return products.sort((a,b) => a.capacity - b.capacity);
                    
                    return this.addonProducts.filter(x => !addonCartIds.includes(x.id) && x.tags.every(y => !y.includes("Brandable Swag") && !y.toLowerCase().includes("Pairs_exclude"))).sort((a,b) => a.capacity - b.capacity).slice(0,3);
                }
            }

            return [];
        },
        gifsPrice(){
            if(this.selectedAddonProducts.length > 0){
               return this.selectedAddonProducts.map(x => x.variants.length ? parseFloat(x.variants[0].price * x.quantity) : 0)
                .reduce((prev, next) => prev + next, 0);
            }

            return 0;
        },
        boxPrice(){
            if(this.selectedBoxProduct)
                return parseFloat(this.selectedBoxProduct.variants[0].price);

            return 0
        },
        cardPrice(){
            if(this.selectedCardProduct){
                return parseFloat(this.selectedCardProduct.variants[0].price);
            }

            return 0;
        },
        feePrice(){
            if(this.feeProduct){
                return parseFloat(this.feeProduct.variants[0].price / 100);
            }

            return 0;
        },
        totalPrice(){
            let total = 0;
            if(this.selectedAddonProducts.length > 0){
               total += this.selectedAddonProducts.map(x => x.variants.length ? parseFloat(x.variants[0].price * x.quantity) : 0)
                .reduce((prev, next) => prev + next, 0);
            }
            if(this.selectedBoxProduct){
                total += parseFloat(this.selectedBoxProduct.variants[0].price);
            }
            if(this.selectedCardProduct){
                total += parseFloat(this.selectedCardProduct.variants[0].price);
            }
            if(this.feeProduct){
                total += parseFloat(this.feeProduct.variants[0].price / 100);
            }

            return total.toFixed(2)
        },
        boxMaxQty(){
            var boxMax =  [250,this.boxQty];
            const min = 1,
            max = Math.max(...boxMax),
            interval = 1;
            const length = (max - min) / interval + 1;
            const arr = Array.from({ length }, (_, i) => min + i * interval);
            return arr;
        },
        shippingPrice(){
            return 12
        },
        boxQty: {
            get(){ return this.$store.state.boxQty},
            set(value){this.$store.commit('setBoxQty', value )}
        },
        boxName: {
            get(){ return this.$store.state.boxName},
            set(value){this.$store.commit('setBoxName', value )}
        },
        leftOverCapacity(){
            return this.currentMaxCapacity - this.currentCapacity;
        },
        lesserMaxCapacity(){
            //get biggest box that is not extended
            let capacities = this.boxProducts.filter(x => !x.title.toLowerCase().includes("extended")).map(x => x.variants).flat().filter(x => x.available).map(x => parseInt(x.option1)).sort((a,b) => b - a);
            return capacities.find(x => x < this.currentMaxCapacity)
        },
        isExtendedBoxes(){
            return this.currentCapacity > this.lesserMaxCapacity;
        },
        extendedProducts(){
            if(this.isExtendedBoxes){
                //find a product that when removed jumps to not extended box
                let cartProducts = JSON.parse(JSON.stringify(this.selectedAddonProducts))
                let products = cartProducts.filter(x => !x.tags.some(tag => tag.includes("Overflow_trigger"))).sort((a,b) => b.capacity - a.capacity);
                let titles = [];
                let capacity = Number(this.currentCapacity);
                for(let i = 0; capacity > this.lesserMaxCapacity; i++){
                    titles.push(products[i].title);
                    capacity = capacity - (products[i].capacity * products[i].quantity);
                }

                return titles.join(", ");
            }

            return null
        },
        totalQtyProducts(){
            return this.selectedAddonProducts.map(x => x.quantity).reduce((prev, next) => prev + next, 0);
        },
        shouldHover(){
            if(this.canAddMore == false && this.isHovering == true){
                return true;
            }
            return false;
        },
        canAddMore(){
            var canAddArray = this.selectedAddonProducts.every((x) =>{
                return ((this.boxQty + 1) * x.quantity) <= this.productCurrentVariantInventory(x)
            })

            return canAddArray
        },
        hasCustomProducts(){
            return this.selectedAddonProducts.some(x => x.tags.some(y => y.includes("Customizable")))
        },
        hasOnDemandProducts(){
            return this.selectedAddonProducts.some(x => x.variants[0].sku.toLowerCase().includes("ondemand"))
        },
        customAlert(){
            let productList = this.selectedAddonProducts.filter(x => x.tags.some(x => x.includes("QTYMIN") && !x.includes("DEMAND")));
            if(productList.length > 0){
                var productTitles = productList.map(x => x.title);
                let minQtys = productList.map((x) =>{
                    let minTag = x.tags.find(x => x.includes("QTYMIN") && !x.includes("DEMAND"));
                    if(minTag){
                        minTag = minTag.split("_");
                        minTag = minTag[minTag.length - 1];
                        return minTag;
                    }

                    return 1
                })
                let maxQty = Math.max([...minQtys])
                return `Please note: "${productTitles.join(", ")}" requires a minimum of ${maxQty} units to be included in your boxes. If you lower your box quantity below this amount, this item will be removed`
            }

            return null
        },
        bundleText(){
            if(!this.selectedCardProduct)
                return "You haven't selected your card!"
            else if(this.isloading){
                return "loading..."
            }
            else 
                return "Complete & Go to Cart"
        },
        bundleSecondaryText(){
            if(!this.selectedCardProduct)
                return "Select your card"
            else 
                return "Complete & Keep Shopping"
        },
        productQtyCopy(){
            if(this.totalQtyProducts == 1)
                return "Great start! We recommend adding a few more items to fill your gift box."
            if(this.totalQtyProducts < 5)
                return "Nice picks! Pro-tip: boxes look best with 5-7 items"
            if(this.totalQtyProducts < 8)
                return "Wow, this gift looks fantastic."
            if(this.totalQtyProducts >= 8)
                return "You’re a gifting pro! They’re going to love it."

            return null;
        }
    },
    methods:{
        removeProduct(product){
            this.$store.commit('removeSelectedAddonProductNew', product);
        },
        expandCart(expand){
            this.expanded = expand;
        },
        editName(edit){
            this.showBoxAlert = false;
            this.isEditingName = edit;
        },
        incrementBoxQty(increment){
            if(increment){
                this.changeBoxQty(this.boxQty + 1)
            }
            else {
                if(this.boxQty > 1){
                    this.changeBoxQty(this.boxQty - 1)
                }
            }
        },
        addonMaxQty(addon){
            const min = 1,
            max = this.getProductMaxQty(addon),
            interval = 1;
            const length = (max - min) / interval + 1;
            let arr = Array.from({ length }, (_, i) => min + i * interval);

            if(this.demandQtyMin(addon) > 0){
                arr = this.checkOnDemandArray(arr,addon);
            }

            return arr;
        },
        getProductMaxQty(addon){
            //Get max value posible in products, no more than the product limit per box
            var maxValues = [this.productLimit]
            //Get limit based on inventory * total boxes
            let inventoryQty = this.productCurrentVariantInventory(addon)
            maxValues.push(Math.floor( inventoryQty / this.boxQty));
            //Get limit based on currentCapacity
            let maxPerCapacity = Math.max(...[Math.floor((this.currentMaxCapacity - this.currentCapacity) / addon.capacity + this.getProductCurrentQty(addon)),this.getProductCurrentQty(addon)])
            maxValues.push(maxPerCapacity);
            return Math.min(...maxValues)
        },
        getProductCurrentQty(currentProduct){
          var product = this.selectedAddonProducts.find(x => x.id == currentProduct.id);
          if(product)
            return product.quantity
          return 0
        },
        updateReccomendedAddonProductQuantity(product){
            var productQty = this.getProductCurrentQty(product) + 1;
            this.$store.commit('updateSelectedAddonProductsNew',{product: product, quantity: productQty});
        },
        changePage(increment){
            this.$emit("changepage", increment);
        },
        changeBoxQty(qty){
            //Validate if cart products can support box qty if not show alert
            this.selectedBoxQty = qty ? qty : this.selectedBoxQty
            var canUpdate = this.selectedAddonProducts.filter((x) =>{
                let demandQty = this.demandQtyMin(x);
                if(demandQty >= this.selectedBoxQty)
                    return false
                if((this.selectedBoxQty * (x.quantity)) > this.productCurrentVariantInventory(x) )
                    return true

                return false
            })

            let customizableUpdate = this.selectedAddonProducts.filter((x) =>{
                if(x.tags.some(x => x.includes("QTYMIN") && !x.includes("DEMAND"))){
                    let minTag = x.tags.find(x => x.includes("QTYMIN") && !x.includes("DEMAND"));
                    if(minTag){
                        minTag = minTag.split("_");
                        minTag = minTag[minTag.length - 1];
                        if(this.selectedBoxQty < parseInt(minTag)){
                            return true;
                        }
                    }
                }

                return false
            })

            let ondemandUpdate = this.selectedAddonProducts.filter((x) =>{
                let demandQty = this.demandQtyMin(x);
                if(demandQty > 0){
                    let product = this.addonProducts.find(y => y.id == x.id);
                    let notDemand = product.variants.find(y => !y.sku.toLowerCase().includes("ondemand"));
                    if(this.selectedBoxQty * x.quantity < demandQty && notDemand.inventory_quantity < this.selectedBoxQty * x.quantity){
                        return true;
                    }
                }

                return false
            })

            

            if(customizableUpdate.length > 0){
                this.openBoxQtyCustomConfirmation(customizableUpdate);
            }
            else if(ondemandUpdate.length > 0){
                this.openBoxQtyOnDemandConfirmation(ondemandUpdate);
            }
            else if(canUpdate.length > 0){
                this.openBoxQtyConfirmation(canUpdate);
            }
            else {
                this.boxQty = this.selectedBoxQty;
                this.checkOnDemand();
            }
        },
        openBoxQtyConfirmation(productList){
            var productTitles = productList.map(x => x.title);
            const alertText = `<p class="title">Uh oh</p><p>The following product(s) don't have enough inventory to match the quantity of boxes you've requested: ${productTitles.join(", ")} . Here are your options:</p>`
            Swal.fire({
                iconHtml: `<img src="https://cdn.shopify.com/s/files/1/1363/8433/files/error_icon_2a88e148-df0e-480c-85b8-89b7d9d6e5ba.svg?v=1741881886" class="alert-icon"/>`,
                html: alertText,
                showCancelButton: true,
                confirmButtonText: "I'll remove them from all boxes (& maybe add something else!)",
                cancelButtonText: "I'll take what you have (& reduce my number of boxes)",
                customClass:{
                container:"swal-custom-container",
                popup: "swal-custom-popup-3",
                title:"swal-title",
                confirmButton: "happybox-button green border",
                cancelButton: "happybox-button white border",
                },
                buttonsStyling: false,
                }).then((result) => {
                if (result.isConfirmed) {
                    for(let addon of productList){
                        this.removeProduct(addon);
                    }
                    this.boxQty = this.selectedBoxQty
                    this.checkOnDemand();
                } else if ( result.dismiss === Swal.DismissReason.cancel )
                {
                    this.selectedBoxQty = this.boxQty;
                }
                else{
                    this.selectedBoxQty = this.boxQty;
                }
            })
        },
        openBoxQtyOnDemandConfirmation(productList){
            var productTitles = productList.map(x => x.title);
            let minQtys = productList.map((x) =>{
                let minTag = x.tags.find(x => x.includes("DEMAND_QTYMIN"));
                if(minTag){
                    minTag = minTag.split("_");
                    minTag = minTag[minTag.length - 1];
                    return minTag;
                }

                return 1
            })
            let maxQty = Math.max([...minQtys])
            const alertText = `Please note: "${productTitles.join(", ")}" requires a minimum of ${maxQty} units to be included in your boxes. If you lower your box quantity below this amount, this item will be removed`
            Swal.fire({
                title: 'Uh oh...',
                text: alertText,
                showCancelButton: true,
                confirmButtonText: "I'll remove them from all boxes (& maybe add something else!)",
                cancelButtonText: "I'll keep my boxes",
                reverseButtons: true,
                customClass:{
                    container:"swal-custom-container",
                    popup: "swal-custom-popup-2",
                    title:"swal-title",
                    confirmButton: "happybox-button green border",
                    cancelButton: "happybox-button white border",
                },
                buttonsStyling: false,
                }).then((result) => {
                if (result.isConfirmed) {
                    for(let addon of productList){
                        this.removeProduct(addon);
                    }
                    this.changeBoxQty();
                } else if ( result.dismiss === Swal.DismissReason.cancel )
                {
                    this.selectedBoxQty = this.boxQty;
                }
                else{
                    this.selectedBoxQty = this.boxQty;
                }
            })
        },
        openBoxQtyCustomConfirmation(productList){
            const alertText = this.customAlert;
            Swal.fire({
                title: 'Uh oh...',
                text: alertText,
                showCancelButton: true,
                confirmButtonText: "I'll remove them from all boxes (& maybe add something else!)",
                cancelButtonText: "I'll keep my boxes",
                reverseButtons: true,
                customClass:{
                    container:"swal-custom-container",
                    popup: "swal-custom-popup",
                    title:"swal-title",
                    confirmButton: "happybox-button green border",
                    cancelButton: "happybox-button white border",
                },
                buttonsStyling: false,
                }).then((result) => {
                if (result.isConfirmed) {
                    for(let addon of productList){
                        this.removeProduct(addon);
                    }
                    this.changeBoxQty();
                } else if ( result.dismiss === Swal.DismissReason.cancel )
                {
                    this.selectedBoxQty = this.boxQty;
                }
                else{
                    this.selectedBoxQty = this.boxQty;
                }
            })
        },
        checkName(){
            if(this.boxName == ""){
                this.boxAlert = "Box name cannot be empty";
                this.showBoxAlert = true;
                this.boxName = this.defaulBoxName;
            }
            else if (this.cartNames.includes(this.boxName)){
                this.boxAlert = "Another box has the same name"
                this.showBoxAlert = true;
                this.boxName = this.defaulBoxName;
            }
            else {
                this.boxAlert = ""
                this.showBoxAlert = false;
            }
            let that = this;
            setTimeout(() => {that.showBoxAlert = false;}, 2000);
            this.isEditingName = false;
        },
        removeAll(){
            this.$store.commit('updateAllSelectedAddonProducts', []);
            this.expandCart(false);
        },
        openModalProduct(product){
            this.$emit("openmodal",product);
            this.expandCart(false);
        },
        getProductImage(product){
            if(product.properties){
                let hasImage = product.properties.find(y => y.name == "_customUrl");
                if(hasImage){
                    return hasImage.value;
                }
            }
            if(product.variants[0].featured_image){
                return product.variants[0].featured_image.src;
            }

            return (product.images.length > 0) ? product.images[product.images.length - 1].src : '';
            
        },
        isOnDemand(addon){
            let product = this.addonProducts.find(x => x.id == addon.id);
            return product.variants.some(x => x.sku.toLowerCase().includes("ondemand"));
        },
        isOverflow(addon){
            let product = this.addonProducts.find(x => x.id == addon.id);
            return product.tags.some(tag => tag.includes("Overflow_trigger"));
        },
        productCurrentVariantInventory(product){
            if(this.isOnDemand(product))
                return 9999;
            return product.variants[0].inventory_quantity;
        },
        changeOnDemand(addonProduct){
            if(this.isOnDemand(addonProduct)){
                let product = this.addonProducts.find(x => x.id == addonProduct.id);
                var variantProduct = JSON.parse(JSON.stringify(product));
                let notDemand = variantProduct.variants.find(x => !x.sku.toLowerCase().includes("ondemand"));
                let onDemand = variantProduct.variants.find(x => x.sku.toLowerCase().includes("ondemand"));
                if(notDemand.inventory_quantity >= addonProduct.quantity * this.boxQty  || this.demandQtyMin(addonProduct) > this.boxQty * addonProduct.quantity){
                    variantProduct.variants = [notDemand];
                }
                else 
                    variantProduct.variants = [onDemand];

                if(addonProduct.variants[0].id != variantProduct.variants[0].id){
                    this.$store.commit('updateSelectedAddonProductsNew',{product: addonProduct, quantity: 0});
                    this.$store.commit('updateSelectedAddonProductsNew',{product: variantProduct, quantity: addonProduct.quantity});
                }
            }
        },
        checkOnDemand(){
            let cartIds = this.selectedAddonProducts.map(x => x.id);
            let onDemandProducts = this.addonProducts.filter(x => cartIds.includes(x.id) && x.variants.some(y => y.sku.toLowerCase().includes("ondemand")));
            if(onDemandProducts.length > 0){
                let ondemandIds = onDemandProducts.map(x => x.id);
                let ondemandCartProducts = this.selectedAddonProducts.filter(x => ondemandIds.includes(x.id));
                for(let addon of ondemandCartProducts){
                    this.changeOnDemand(addon)
                }
            }
        },
        demandQtyMin(addon){
            let demandQtymin = addon.tags.find(x => x.includes("DEMAND_QTYMIN"));
            if(demandQtymin){
                if(demandQtymin){
                    demandQtymin = demandQtymin.split("_");
                    demandQtymin = demandQtymin[demandQtymin.length - 1];

                    return  parseInt(demandQtymin);
                }
            }

            return 0;
        },
        checkOnDemandArray(arr,addon){
            let demandMinQty = this.demandQtyMin(addon);
            let product = this.addonProducts.find(x => x.id == addon.id);
            const notDemand = product.variants.find(x => !x.sku.toLowerCase().includes("ondemand"));
            const notDemandInventory = notDemand.inventory_quantity;
            for(let int of arr){
                if((int * this.boxQty) < demandMinQty && (int * this.boxQty) > notDemandInventory)
                arr.splice(int-1,1);
            }

            return arr;
        },
        bundle(isContinue){
            if(this.selectedAddonProducts.length > 0 && this.selectedBoxProduct && this.selectedCardProduct && this.cardHasMessage){
                this.isloading = true;
                this.$emit("bundle",isContinue);
            }
            else{
                this.expandCart(false);
                this.changePage(true);
                if(this.selectedAddonProducts.length > 0 && this.selectedBoxProduct && this.selectedCardProduct && !this.cardHasMessage){
                    this.$store.commit('setShowCardAlert', true );
                    this.$emit("errormodal", `<p class="title">To proceed to the next step,<br/> please write your card message</p>`);
                }
            }
        },
        next(){
            if(this.cardHasMessage){
                this.expandCart(true)
            }
            else if(!this.cardHasMessage && !this.selectedCardProduct){
                this.changePage(true);
            }
            else if(!this.cardHasMessage && this.selectedCardProduct){
                this.$emit("cardwarning");
            }
        },
        scrollBottom(){
            setTimeout(() => {
                    let elements = document.getElementsByClassName("scrollList");
                    for(let element of elements){
                        element.scrollTop = element.scrollHeight;
                    }
                }, 100);
        },
        goStep(step){
            this.$emit("gostep",step);
            this.expanded = false;
        },
        handleScroll(event) {
            this.updateVisibleProducts();
        },
        updateVisibleProducts() {
            this.visibleProducts.clear();
            const container = document.getElementById('products-scroll-container');
            if (!container) return;

            const containerRect = container.getBoundingClientRect();
            const containerTop = containerRect.top;
            const containerBottom = containerRect.bottom;

            this.selectedAddonProducts.forEach((product, index) => {
                const productElement = document.getElementById(`product-${index}`);
                if (!productElement) return;

                const productRect = productElement.getBoundingClientRect();
                const productTop = productRect.top;
                const productBottom = productRect.bottom;
                const productHeight = productRect.height;

                // Check if more than 50% of the product is visible in the container
                const visibleTop = Math.max(productTop, containerTop);
                const visibleBottom = Math.min(productBottom, containerBottom);
                const visibleHeight = Math.max(0, visibleBottom - visibleTop);
                const visibilityPercentage = visibleHeight / productHeight;

                if (visibilityPercentage > 0.5) {
                    this.visibleProducts.add(index);
                }
            });
            
            // Force Vue to update the overflow alert positions
            this.$forceUpdate();
        },
        isProductVisible(index) {
            return this.visibleProducts.has(index);
        },
        getOverflowAlertStyle(index) {
            const productElement = document.getElementById(`product-${index}`);
            const containerElement = document.getElementById('products-scroll-container');
            const cartHeaderElement = document.getElementById('cart-header');
            
            if (!productElement || !containerElement) {
                return {};
            }
            
            const productRect = productElement.getBoundingClientRect();
            const containerRect = containerElement.getBoundingClientRect();
            
            const relativeTop = productRect.top - containerRect.top + cartHeaderElement.offsetHeight;
            
            return {
                position: 'absolute',
                top: `${relativeTop}px`,
                transform: 'translateY(-50%)',
                zIndex: 10
            };
        },
        handleResize() {
            this.updateVisibleProducts();
        }
    },
    mounted() {
        this.selectedBoxQty = this.boxQty;
        this.$nextTick(() => {
            this.updateVisibleProducts();
        });
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    }
}
</script>

<style lang="scss" scoped>

.cart-container{
    width: 0%;
    height: 100%;
    display: none;
}

.cart-container.hasProduct{
    width: 100%;
    display: block;
    min-width: 10%;
    z-index: 3;
    margin-top: -7vh;
}

.sticky.cart-container.hasProduct{
    width: 10%;
    margin-top: unset;
}

.cart-container.global{
    position: fixed;
    width: 10%;
    right: 0px;
    top: 0px;
    background-color: white;
    margin-top: unset;
}

.sticky.cart-container.global{
    top: 6vh;
}

.sticky.cart-container.hasProduct.expanded{
    width: 100%;
    height: calc(100vh - 5vh);
    top: 6vh;
    bottom: 0;
    position: fixed;
    z-index: 3;
}

.cart-container.expanded{
    width: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    position: fixed;
    top: 0px;
    left: 0%;
    display: flex;
    justify-content: flex-end;
    height: 100vh;
    z-index: 4;
    margin-top: unset;
}

.separator{
    width: 100%;
    height: 1px;
    background-color: #D1D5DB;
    margin: 2% 0%;
}

//Unexpanded cart css
.unexpanded-cart{
    width: 100%;
    height: 100%;
    box-shadow: 0px 10px 15px rgba(31, 41, 55, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center;
    position: sticky;
    top: 1vh;
    height: 100vh;
}

.unexpanded-cart.sticking{
    height: calc(100vh - 48px);
    top: 48px;
}

.price-container{
    display: flex;
    flex-direction: column;
    text-align: center;
    box-shadow: inset 0px 1px 0px #E6E8EC;
    width: 100%;
    padding: 5% 0%;
    position: sticky;
    bottom: 0;
}

.price-container .title{
    font-weight: bold;
    font-size: 1.15vw;
}

.price-container .price{
    font-size: 1.3vw;
}

.unexpanded-cart .expand-arrow{
    position: absolute;
    background-color: white;
    border-bottom: 1px solid #E5E7EB;
    border-left: 1px solid #E5E7EB;
    border-top: 1px solid #E5E7EB;
    border-radius: 4px 0px 0px 4px;
    top: 5%;
    left: -25%;
    width: 25%;
    height: fit-content;
    padding: 1rem 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #374151;
    font-size: 2vw;
    cursor: pointer;
    flex-direction: column;
}

.expand-arrow span{
    font-size: 1vw;
    writing-mode: sideways-lr;
        font-weight: bold;
}

.qty-box-title{
    font-weight: bold;
    font-size: 1.15vw;
    line-height: 1.5;
}

#boxqtyselector{
    background-color: #FFFFFF;
    border: 1px solid #F3EEFA;
    box-shadow: 0px 1px 2px #1f293714;
    border-radius: 4px;
    padding: 0% 0% 0% 10%;
    height: unset;
    width: 70%;
    margin-bottom: 1rem;
}

.products-container-title{
    font-weight: bold;
    font-size: 1.15vw;
    line-height: 1.5;
    padding: 10% 0%;
}

.unexpanded-cart .products-container{
    width: 90%;
    display: flex;
    flex-direction: column;
    list-style: none;
    justify-content: flex-start;
    margin: unset;
    max-height: 67%;
    flex: 1;
    overflow-y: scroll ;
}

.global .unexpanded-cart .products-container{
    max-height: 74%;
}

.sticky .unexpanded-cart .products-container{
    max-height: 74%;
}


.unexpanded-cart .products-container li{
    width: 100%;
    margin-bottom: 1vw;
    position: relative;
}

.unexpanded-cart .addon-container{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

.unexpanded-cart .addon-container .main-image{
    width: 90%;
    background-color: #f6f6f6;
    border: unset;
    margin-bottom: 5%;
}

.addon-container select{
    width: 50%;
    background-color: #FFFFFF;
    border: 1px solid #F3EEFA;
    box-shadow: 0px 1px 2px #1f293714;
    border-radius: 4px;
    padding: 0% 0% 0% 10%;
    height: unset;
    margin-right: 10%;
}
.delete-button{
    width: 30%;
    background: #FFFFFF;
    border-radius: 4px;
    cursor: pointer;
}

.delete-button.disabled{
    opacity: 0.5;
}

.addon-container .edit-container{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.switch-button{
    width: 30%;
    padding: 6%;
    border-radius: 4px;
    cursor: pointer;
    box-shadow: 0 1px 2px #1f293714;
    border: 1px solid #F3EEFA;
}

.addon-container p{
    font-size: 1.15vw;
    font-weight: bold;
    cursor: pointer;
}

.product-qty-container .switch-button{
    width: 20%;
    margin: unset;
    padding: 3%;
}

.expand-cart.bottom{
    background: #FFFFFF;
    padding: 10px;
    width: 100%;
}

.expand-cart.bottom button{
    background-color: #5cffc0;
    padding: 8% 0%;
    width: 100%;
    box-shadow: 0px 1px 2px #1f293714;
    border-radius: 100px;
    transform: matrix(1, 0, 0, 1, 0, 0);
    font-family: 'Karla';
    font-style: normal;
    font-weight: 700;
    font-size: 1.15vw;
    line-height: 1.5;
    text-align: center;
    color: #0F0C38;
    border: 1px solid #0F0C38;
}

.expand-cart.bottom button:disabled{
  opacity: 0.6;
}

.expand-cart.bottom button:hover{
    background-color: #27F0A2;
}

//Expanded Cart Css
.expanded-cart{
    width: 72%;
    height: 100%;
    background-color: white;
    display: flex;
    position: relative;
}

.expanded-cart .expand-arrow{
    position: absolute;
    background-color: white;
    border-bottom: 1px solid #E5E7EB;
    border-left: 1px solid #E5E7EB;
    border-top: 1px solid #E5E7EB;
    border-radius: 4px 0px 0px 4px;
    top: 10%;
    left: -3.5%;
    width: 3.5%;
    line-height: 1.2;
    display: flex;
    justify-content: center;
    color: #374151;
    font-size: 2vw;
    cursor: pointer;
    align-items: center;
    flex-direction: column;
    padding: 1% 0;
}

.product-summary-container{
    width: 60%;
    display: flex;
    flex-direction: column;
    padding: 0% 2%;
    overflow-y: scroll;
}

.product-summary{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border: 1px solid #E8E1F2;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 16px;
}

.price-summary-container{
    width: 40%;
    background-color: #F9FAFB;;
    padding: 0% 2%;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    height: 100%;
    position: relative
}

.box-name-container{
    width: 100%;
    display: flex;
    padding: 3% 0%;
}

.box-name{
    font-weight: bold;
    line-height: 1.33;
    font-size: 1.67vw;
}

.box-name-legend{
    color: #66498C;
    line-height: 1.43;
    font-size: 1vw;
    padding-left: 3%;
    display: flex;
    align-items: center;
    width: 65%;
}

.box-name-legend img{
    width: 4%;
    margin-right: 2%;
}

.expanded-cart .products-container{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    justify-content: space-between;
    margin: unset;
    padding: 5% 2%;
}


.expanded-cart .products-container li{
    width: 45%;
    margin-bottom: 2%;
}

.expanded-cart .addon-container{
    width: 100%;
    display: flex;
    align-items: center;
}

.expanded-cart .addon-container .image-container{
    width: 40%;
    display: flex;
}

.expanded-cart .addon-container .main-image{
    width: 100%;
    height: auto;
    background-color: #f6f6f6;
    cursor: pointer;
}

.expanded-cart .product-information{
    width: 60%;
    display: flex;
    flex-direction: column;
    padding-left: 5%;
    justify-content: space-between;
}

.expanded-cart .product-information .title{
    line-height: 1.43;
    font-size: 0.9vw;
    font-weight: bold;
    cursor: pointer;
}

.expanded-cart .product-information .price{
    line-height: 1.43;
    font-size: 1vw;
}

.product-qty-container{
    width: 100%;
    display: flex;
}

.product-qty-container select{
    background-color: #FFFFFF;
    border: 1px solid #E4E4E7 !important;
    box-shadow: 0px 1px 2px #1f293714;
    border-radius: 4px !important;
    height: unset !important;
    padding: 1% 2% !important;
    text-align: center;
    font-size: 1.3vw;
    width: 80% !important;
    line-height: 1.5;
    -moz-appearance: textfield;
}

.product-qty-container .delete-button{
    width: 20%;
}

.box-container{
    background-color: #F9FAFB;
    margin-top: 2%;
    padding: 0% 2% 2% 2%;
    border-radius: 4px;
    border: 1px solid lightgray;
    margin-bottom: 2%;
}

.box-qty-container{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 3%;
    border-bottom: 1px solid lightgray;
    margin-bottom: 3%;
    padding-bottom: 1%;
}
.box-qty-container p{
    font-family: 'Karla';
    font-style: normal;
    font-weight: 700;
    font-size: 1.2vw;
    line-height: 1.5;
    color: #0F0C38;
}


.box-qty-input-container{
    width: 50%;
    display: flex;
    justify-content: flex-end;
}

.box-qty-input-container input{
    background-color: #FFFFFF;
    border: 1px solid #E4E4E7 !important;
    box-shadow: 0px 1px 2px #1f293714;
    border-radius: 4px !important;
    height: unset !important;
    padding: 1% 2% !important;
    text-align: center;
    font-size: 1.3vw;
    width: 20% !important;
    line-height: 1.5;
    -moz-appearance: textfield;
    color: #0F0C38;
}

.box-qty-input-container input::-webkit-inner-spin-button,
.box-qty-input-container input::-webkit-outer-spin-button{
   -webkit-appearance: none;
    margin: 0;
}

.box-qty-input-container button{
    background-color: #FFFFFF;
    border: 1px solid #E4E4E7;
    box-shadow: 0px 1px 2px #1f293714;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2vw;
    padding: 0% 4%;
    line-height: 0;
    margin: 0% 2%;
    color: #0F0C38;
}

.box-qty-input-container button:hover{
    background-color: #faf7fe
}

.multiship-notice{
    font-family: 'Karla';
    font-style: normal;
    font-weight: 400;
    font-size: 1.1vw;
    line-height: 1.5;
    color: #0F0C38;
}

.custom-notice{
    font-family: 'Karla';
    font-style: normal;
    font-weight: 400;
    font-size: 1.1vw;
    line-height: 1.5;
    color: #581C87;
    margin-top: 2%;
}

.recommendation-container{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 2%;
    border-radius: 4px;
    border: 1px solid lightgray;
}

.recommendation-container .title{
    width: 100%;
    font-family: 'Karla';
    font-style: normal;
    font-weight: 700;
    font-size: 1.25vw;
    line-height: 1.6;
    color: #0F0C38;
    padding-bottom: 1%;
    margin-bottom: 2%;
    border-bottom: 1px solid lightgray;
}

.recommended-addon-container{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.recommended-addon{
    width: 30%;
    display: flex;
    flex-direction: column;
}

.recommended-addon .main-image{
    width: 100%;
    margin-bottom: 5%;
    height: auto;
}

.recommended-addon .addon-title{
    font-weight: 700;
    font-size: 1.05vw;
    line-height: 1.3;
    color: #0F0C38;
    margin-top: 5%;
}

.recommended-addon .price{
    font-size: 1.05vw;
    line-height: 1.3;
    color: #3F3D60;
}

.happybox-button.white{
    padding: 3% 0%;
}

.notice-container{
    background: white;
    border: 1px solid #F5EEFE;
    border-radius: 4px;
    box-sizing: border-box;
    width: 100%;
    padding: 4%;
    margin: 2% 0%;
    display: flex;
}

.notice-container .title{
    font-size: 1.15vw;
    font-weight: bold;
    line-height: 1.5;
}

.notice-container .subtitle{
    font-size: 1.15vw;
    line-height: 1.5;
}

.notice-container a{
    font-size: 1vw;
    text-decoration: underline;
    color: #a01adb;
    cursor: pointer;
}

.notice-container .main-image {
    width: 20%;
    padding: 1%;
    margin-right: 5%;
}

.summary-title,.summary-subtitle{
    font-size: 1.25vw;
    line-height: 1.5;
    margin: unset;
    color: #0F0C38
}
.summary-title{
    font-weight: bold;
    margin-bottom: 2%;
    border-bottom: 1px solid lightgray;
    padding-bottom: 1%;
    width: 100%;
}

.x-container{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin: 5% 0% 3%;
    position: sticky;
    top: 2.5%;
}

.x-button{
    width: 24px;
    height: 24px;
    color: black;
    font-size: 1.8vw;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.product-summary .remove-all{
    text-align: right;
    font-size: 1.15vw;
}

    .price-summary-container .main-title{
        font-family: ff-more-web-pro-condensed, Karla, sans-serif;
        font-size: 1.5vw;
        line-height: 1.45;
        display: flex;
        align-items: center;
        letter-spacing: 0.03em;
        color: #0F0C38;
    }

    .item-summary{
        border-top: 1px solid #D1D5DB;
        padding: 3% 0%;
    }

    .item-title{
        font-weight: 700;
        font-size: 2vw;
        line-height: 1.5;
        color: #0F0C38;
        padding-bottom: 1%;
        margin-bottom: 3%;
        border-bottom: 1px solid lightgray;
    }

    .subtotal-container,.taxes-container{
        display: flex;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        color: #0F0C38;
        font-family: 'Karla';
        font-style: normal;
        font-weight: 700;
    }

    .subtotal-container p,.taxes-container p{
        margin: unset;
    }

    .subtotal-container{
        font-size: 1.4vw;
        line-height: 1.6;
        padding-bottom: 5%;
    }

    .taxes-container{
        font-size: 1.15vw;
        line-height: 150%;
        border-top: 1px solid #D1D5DB;
        padding-top: 3%;
    }

    .taxes-container strong{
        font-weight: 400;
    }

    .box-total{
        width: 100%;
        font-weight: 400;
        font-size: 1.15vw;
        line-height: 1.4;
        color: #0F0C38;
        margin-bottom: 5%;
    }

    .box-total p,.item-total p{
        margin: unset;
    }

    .total-container{
        display: flex;
        justify-content: space-between;
    }

    .individual-price{
        font-style: italic;
    }

    .item-total{
        display: flex;
        justify-content: space-between;
        width: 100%;
        font-weight: 700;
        font-size: 1.15vw;
        line-height: 150%;
        color: #0F0C38;
    }

    .total-container .service-fee{
        color: #5048E5;
    }

    .blue-legend{
        font-family: 'Karla';
        font-size: 1vw;
        line-height: 1.43;
        color: #5048E5;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    .purple-legend{
        font-family: 'Karla';
        font-size: 1vw;
        line-height: 1.43;
        color: #66498c;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    .blue-legend img{
        width: 3%;
        margin-right: 2%;
    }

    .complete-box{
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 5%;
        background-color: #f9fafb;
        position: sticky;
        bottom: 0%;
        flex-direction: column;
        gap: 10px;
    }

    .complete-box .happybox-button{
        width: 100%;
    }


    .multiship-block{
        background-color: #fdfddc;
        border: 1px solid gray;
        font-size: 0.8vw;
        border-radius: 8px;
        text-align: center;
        padding: .5rem 0.5rem;
        position: absolute;
        right: 10%;
        bottom: 15%;
        line-height: 1.2;
        width: 115%;
        z-index: 1;
    }

    .multiship-block .close{
        position: absolute;
        border-radius: 50%;
        background-color: #fff;
        line-height: 1;
        border: 1px solid gray;
        aspect-ratio: 1;
        font-size: 0.8rem;
        width: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
        top: -.5rem;
        right: -.5rem;
    }

    .multiship-block a{
        text-decoration: underline;
        color: #a01adb;
        cursor: pointer;
        font-size: inherit;
    }

    .multiship-block .arrow-t {
        width: 0;
        height: 0;
        border-top: 10px solid gray;
        border-right: 7px solid transparent;
        border-left: 7px solid transparent;
        position: absolute;
        bottom: -10px;
        right: 5px;
    }

    .multiship-block .arrow-t .inner {
        position: relative;
        top: -11px;
        right: 6px;
        width: 0;
        height: 0;
        border-top: 9.5px solid #fdfddc;
        border-right: 6.5px solid transparent;
        border-left: 6.5px solid transparent;
    }


.extended-block,.overflow-alert{
    background-color: #ffebe0;
    border: 1px solid #D0CFBB;
    font-size: 0.9vw;
    border-radius: 8px;
    text-align: center;
    padding: 0.5rem 0.5rem;
    position: absolute;
    left: 5%;
    right: 5%;
    top: 5%;
    bottom: 25%;
    line-height: 1.2;
    z-index: 1;
}

.extended-block .close,.overflow-alert .close{
    position: absolute;
    border-radius: 50%;
    background-color: #fff;
    line-height: 1;
    border: 1px solid gray;
    aspect-ratio: 1;
    font-size: 0.8rem;
    width: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    top: -.5rem;
    right: -.5rem;
}

.extended-block .arrow-t,.overflow-alert .arrow-t {
    width: 0;
    height: 0;
    border-top: 10px solid #D0CFBB;
    border-right: 7px solid transparent;
    border-left: 7px solid transparent;
    position: absolute;
    bottom: -10px;
    right: 5%;
}

.extended-block .arrow-t .inner,.overflow-alert .arrow-t .inner {
    position: relative;
    top: -11px;
    right: 6px;
    width: 0;
    height: 0;
    border-top: 9.5px solid #ffebe0;
    border-right: 6.5px solid transparent;
    border-left: 6.5px solid transparent;
}

.overflow-alert{
    background-color: #fdfde2;
    right: 70%;
    width: max-content;
    left: unset;
    bottom: unset;
    top: unset;
    transform: translateY(-50%);
}
.overflow-alert .arrow-t .inner{
    border-top: 9.5px solid #fdfde2;
}

.alert-overlay{
    left: 5%;
    right: 5%;
    top: 0%;
    bottom: 25%;
    z-index: 1;
    background-color: rgba(253, 253, 226, 0.5);
    position: absolute;
}

.overflow-product{
    position: static !important;
}

.overflow-alert.hidden {
    display: none !important;
}

.alert-icon{
    width: 20%;
    position: absolute;
    top: 5%;
    right: 15%;
    cursor: pointer;
    z-index: 1;
    animation: wobble 2s ease infinite;
}

@keyframes wobble {
  0% { transform: translateX(0%); }
  15% { transform: translateX(-25%) rotate(-5deg); }
  30% { transform: translateX(20%) rotate(3deg); }
  45% { transform: translateX(-15%) rotate(-3deg); }
  60% { transform: translateX(10%) rotate(2deg); }
  75% { transform: translateX(-5%) rotate(-1deg); }
  100% { transform: translateX(0%); }
}

    @media screen and (max-width: 767px){
        .cart-container{
            display: none !important;
        }
    }

    .purple-copy{
        text-decoration: underline;
        color: #a01adb;
        cursor: pointer;
        font-size: 1.3vw;
    }
</style>